<template>
  <ul class="modal-ui">
    <li>
      <button type="button" class="fullscreen" @click="toggleFullSize">
        <Icon
          v-if="fullSize"
          class="icon"
          size="2rem"
          name="fullScreenOff"
        ></Icon>
        <Icon v-else class="icon" size="2rem" name="fullScreenOn"></Icon>
      </button>
    </li>
    <li>
      <button type="button" class="close" @click="close">
        <Icon class="icon" size="1.2rem" name="closeScreen"></Icon>
      </button>
    </li>
  </ul>
</template>
<script lang="ts" setup>
const route = useRoute();
const { fullSize, toggleFullSize } = inject(INJECT_FUILLSIZE_TOGGLE);
const { routeQueryFrom } = useRouteQueryFrom();
const close = () => {
  const path = routeQueryFrom || route.path;
  navigateTo(path, { replace: true });
};
</script>
<style lang="scss" scoped>
.modal-ui {
  display: flex;
  transition: opacity 200ms $ease-in-quad;
  gap: 1.2rem;
  .icon {
    transition: opacity 200ms $ease-in-quad;
    color: var(--color_neutral_50);
  }
  &:hover,
  &:focus {
    .icon {
      opacity: 1;
    }
  }
}
button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 3rem;
  height: 3rem;
  border-radius: 50%;
  background: var(--color_secondary);
}
.fullscreen {
  display: none;
  background: var(--color_warning);
  @include above('l') {
    display: flex;
  }
}
.close {
  background: var(--color_error);
}
</style>
